import { render, staticRenderFns } from "./DettaglioReparto.vue?vue&type=template&id=4961121b&scoped=true&"
import script from "./DettaglioReparto.vue?vue&type=script&lang=js&"
export * from "./DettaglioReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961121b",
  null
  
)

export default component.exports